import api from 'api'

export default async () => {
  const { data } = await api.get(`/projects`)

  return data
}
